//get premium plan
export const GET_PREMIUM_PLAN = "GET_PREMIUM_PLAN";

//create premium plan
export const CREATE_NEW_PREMIUM_PLAN = "CREATE_NEW_PREMIUM_PLAN";

//edit premium plan
export const EDIT_PREMIUM_PLAN = "EDIT_PREMIUM_PLAN";

//delete premium plan
export const DELETE_PREMIUM_PLAN = "DELETE_PREMIUM_PLAN";

//renewal switch
// export const RENEWAL_SWITCH = "RENEWAL_SWITCH";

//dialog type
export const OPEN_PREMIUM_PLAN_DIALOG = "OPEN_PREMIUM_PLAN_DIALOG";
export const CLOSE_PREMIUM_PLAN_DIALOG = "CLOSE_PREMIUM_PLAN_DIALOG";

//Get premium pla history
export const GET_PREMIUM_PLAN_HISTORY = "GET_PREMIUM_PLAN_HISTORY";

//toast
export const OPEN_PREMIUM_PLAN_TOAST = "OPEN_PREMIUM_PLAN_TOAST";
export const CLOSE_PREMIUM_PLAN_TOAST = "CLOSE_PREMIUM_PLAN_TOAST";
